import { useEffect, useState } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import song1 from '../Data/ExampleMusic.ogg';
import song2 from '../Data/Bleach OST 3-Clavar La Espada.mp3';
import song3 from '../Data/King for a Day.mp3'
import song4 from '../Data/Daft Punk - Harder, Better, Faster, Stronger (Official Audio).mp3';
import song5 from '../Data/Green day - Time of your life with lyrics.mp3';
import song6 from '../Data/Elvis Presley - Don\'t Be Cruel.mp3';
import song7 from '../Data/Elvis Presley - Can\'t Help Falling In Love (Official Audio).mp3';
import song8 from '../Data/Elvis Presley - Jailhouse Rock (Music Video).mp3';
import song9 from '../Data/Patsy Cline -- I Fall To Pieces.mp3'
import song10 from '../Data/Tom MacDonald - _Fake Woke_.mp3';
import song11 from '../Data/California Dreamin\'.mp3';
import song12 from '../Data/Tha Crossroads.mp3';
import song13 from '../Data/MEGALOVANIA.mp3';
import song14 from '../Data/JJK.mp3';

import pic1 from '../Data/Picture1.jpg';
import pic2 from '../Data/Aizen.png';
import pic3 from '../Data/GreenDay1.png';
import pic4 from '../Data/DaftPunk.png';
import pic5 from '../Data/Elvis.png';
import pic6 from '../Data/Patsy.png';
import pic7 from '../Data/tom-macdonald.jpg';
import pic8 from '../Data/MaPas.png';
import pic9 from '../Data/BoneThugs.png';
import pic13 from '../Data/SANESS.png';
import pic14 from '../Data/Gottagetithomie.png';
import createUtilityClassName from 'react-bootstrap/esm/createUtilityClasses';

//ADD EMAIL DARK PATTERN, AD THAT POPS UP AFTER YOU LISTEN TO THE SONG FOR A FEW MINUTES OR SECONDS, 
//AND/OR PREMIUM

function MusicCards(props) {
    const addFavor = (music) => {
        console.log('music data +++', music);
        let musics = JSON.parse(localStorage.getItem('music')) || [];
        if (!musics.includes(music.songName)) {
            console.log('song name ===', music.songName);
            musics.push(music.songName);
            localStorage.setItem('music', JSON.stringify(musics));
            setFavor(!favor);
            //props.setModalShow(true);
            props.setPremiumShow(true);
        }
    };

    const [favor, setFavor] = useState(false);
    const [audioFile, setAudioFile] = useState(null);
    const [picture, setPicture] = useState(null);

    useEffect(() => {
        let musics = JSON.parse(localStorage.getItem('music')) || [];
        if (musics.includes(props.track.songName)) {
            console.log('favor song name ===', musics.includes(props.track.songName));
            setFavor(true);
        }
        switch (props.track.songName) {
            case 'Sick Beat?':
                setAudioFile(song1);
                setPicture(pic1);
                break;
            case 'Clavar La Espada':
                setAudioFile(song2);
                setPicture(pic2);
                break;
            case 'King for a Day':
                setAudioFile(song3);
                setPicture(pic3);
                break;
            case 'Harder, Better, Faster, Stronger':
                setAudioFile(song4);
                setPicture(pic4);
                break;
            case 'Time of your life':
                setAudioFile(song5);
                setPicture(pic3);
                break;
            case 'Don\'t Be Cruel':
                setAudioFile(song6);
                setPicture(pic5);
                break;
            case 'Can\'t Help Falling In Love':
                setAudioFile(song7);
                setPicture(pic5);
                break;
            case 'Jailhouse Rock':
                setAudioFile(song8);
                setPicture(pic5);
                break;
            case 'I Fall To Pieces':
                setAudioFile(song9);
                setPicture(pic6);
                break;
            case 'Fake Woke':
                setAudioFile(song10);
                setPicture(pic7);
                break;
            case 'California Dreamin\'':
                setAudioFile(song11);
                setPicture(pic8);
                break;
            case 'Tha Crossroads':
                setAudioFile(song12);
                setPicture(pic9);
                break;
            case 'Megalovania':
                setAudioFile(song13);
                setPicture(pic13);
                break;
            case 'Lost in Paradise':
                setAudioFile(song14);
                setPicture(pic14);
                break;

            default:
                break;
        }
    }, []);

    return (
        <>
            <div className="card border-secondary mb-3" style={{ display: "inline-block", height: "20%", width: "30%", margin: "20px" }}>
                <h4 className="cardTitle">{props.track.songName}</h4>
                <img className="Bucksimage" src={picture} alt={props.name} style={{ height: "20%", width: "40%"}}/>
                <div className="cardBody">
                    Artist: {props.track.artist}
                     {/* <audio controls preload="auto" style={{ width: '100%' }}>
                        <source type="audio/ogg" src="../Data/ExampleMusic.ogg"/>
                    </audio> */}

                    <ReactAudioPlayer
                        style={{ width: '100%' }}
                        key={props.name}
                        src={audioFile}
                        autoPlay={false}
                        controls
                        preload='metadata'
                    />
                </div>
                <div className='cardBody'>
                    <button
                        type='button'
                        className={favor ? 'btn btn-danger btn-block w-100 mt-1' : 'btn btn-primary btn-block w-100 mt-1'}
                        onClick={() => addFavor(props.track)}
                    >
                        Add to Favorites
                    </button>
                </div>
                <div className="cardSide">
                    <center></center>
                </div>
            </div>


        </>
    );
}

export default MusicCards;